import { useBox } from "@react-three/cannon";
import { useMemo, useRef } from "react";
import { Group, MeshBasicMaterial, TextureLoader } from "three";
import { RoundedBox } from "@react-three/drei";
import { ObjectProps, useDragConstraint } from "../utils";
import { useLoader } from "@react-three/fiber";
import { MailUrl, asset } from "../../consts";

export default ({position, rotation}: ObjectProps) => {
  const logoImage = useLoader(TextureLoader, asset('/images/mail.png'));

  const materials = useMemo(() => {
    const baseMaterial = new MeshBasicMaterial({color: '#d44638'});
    const logoMaterial = new MeshBasicMaterial({ 
      map: logoImage,
      transparent: true,
      alphaTest: 0.1
    });
    
    return [
      baseMaterial.clone(),
      baseMaterial.clone(),
      logoMaterial.clone(),
      logoMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
    ];
  }, [logoImage]);
  const [ref] = useBox(() => ({
    mass: 5,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    args: [2.5, 1, 2.5],
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  const handlePointerEnter = () => { document.body.style.cursor = 'pointer'; };
  const handlePointerLeave = () => { document.body.style.cursor = 'default'; };
  const handleClick = () => { window.open(MailUrl, '_blank'); };
  return (
    <group
      ref={ref}
      {...bind}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onClick={handleClick}
    >
      <RoundedBox
        args={[2.5, 1, 2.5]} 
        radius={0.5} 
        smoothness={4}
        castShadow
        receiveShadow
        material={materials}
      />
      <mesh
        position={[0, 0, 0]}
        rotation={[0, -Math.PI / 2, 0]}
        material={materials}
        receiveShadow>
          <boxGeometry args={[1.75, 1.002, 1.75]} />
        </mesh>
    </group>
  );
};
